exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LicensePlateLookupTool{padding-left:10px}.LicensePlateLookupTool .licensePlateNumberInput{width:150px}.LicensePlateLookupTool .overrideGroup{width:280px !important}.LicensePlateLookupTool .overrideTextBlock{width:270px !important}", ""]);

